module.exports = __webpack_public_path__ + "static/media/nucypher.c62e8337.svg";